import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

import type { BusinessSubscriptionTier } from "@/shared/types/api/business-mode.types"

export interface BusinessModeState {
  selectedTier: BusinessSubscriptionTier | null
  uploadProgress: number
  isUploading: boolean
}

const initialState: BusinessModeState = {
  selectedTier: null,
  uploadProgress: 0,
  isUploading: false
}

export const businessModeSlice = createSlice({
  name: "businessMode",
  initialState,
  reducers: {
    setSelectedTier: (state, action: PayloadAction<BusinessSubscriptionTier>) => {
      state.selectedTier = action.payload
    },
    setUploadProgress: (state, action: PayloadAction<number>) => {
      state.uploadProgress = action.payload
    },
    startUpload: state => {
      state.isUploading = true
      state.uploadProgress = 0
    },
    finishUpload: state => {
      state.isUploading = false
      state.uploadProgress = 100
    },
    resetUpload: state => {
      state.isUploading = false
      state.uploadProgress = 0
    }
  }
})

export const { setSelectedTier, setUploadProgress, startUpload, finishUpload, resetUpload } = businessModeSlice.actions

export default businessModeSlice.reducer
